import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

export interface IMdlDataGridColumn {
    key: string;
    name: string;
    sortable?: boolean;
    numeric?: boolean;
    editable?: boolean;
    isBoolean?: boolean;
    isText?: boolean;
}

export interface IMdlDataGridModel {
    selected: boolean;
}

export interface IMdlDataGrid {
    columns: Array<IMdlDataGridColumn>;
    data: Array<IMdlDataGridModel>;
}

export class MdlDefaultGrid implements IMdlDataGrid {
    public columns: Array<IMdlDataGridColumn>;
    public data: Array<IMdlDataGridModel> = new Array<IMdlDataGridModel>();

    constructor(columns: Array<IMdlDataGridColumn>, data?: Array<IMdlDataGridModel>) {
        this.columns = columns;
        if (data)
            this.data = data;
    }

    public addAll(data: Array<IMdlDataGridModel>) {
        this.data.push(...data);
    }
}


const template =
    `
    <table class="mdl-data-table">
        <thead>
            <tr>
            <th *ngIf="selectable">
                <mdl-checkbox mdl-ripple [ngModel]="isAllSelected()" (ngModelChange)="toogleAll()"></mdl-checkbox>
            </th>
            <th *ngFor="let column of model.columns" [ngClass]="{'mdl-data-table__cell--non-numeric': !column.numeric}">
                {{column.name}}
            </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of model.data; let i = index" [ngClass]="{'is-selected': selectable && data.selected}">
            <td *ngIf="selectable">
                <mdl-checkbox mdl-ripple [(ngModel)]="data.selected" (ngModelChange)="selectionChanged(data)"></mdl-checkbox>
            </td>
            <td *ngFor="let column of model.columns" [ngClass]="{'mdl-data-table__cell--non-numeric': !column.numeric}">
                <mdl-checkbox *ngIf="column.isBoolean" mdl-ripple [(ngModel)]="data[column.key]" [disabled]="!column.editable"></mdl-checkbox>
                <pre *ngIf="column.isText">{{data[column.key]}}</pre>
            </td>
            </tr>
        </tbody>
    </table>
    `;
const styles = [
    `
    :host{
      display:inline-block;
    }
    `
];
@Component({
    selector: 'mdl-data-grid',
    template: template,
    styles: styles,
    encapsulation: ViewEncapsulation.None
})
export class MdlDataGridComponent {
    @Input('grid-model') public model: IMdlDataGrid;
    @Input('grid-model-selected') public selected: Array<IMdlDataGridModel>;
    @Output('grid-model-selectionChanged') public selectionChange = new EventEmitter();

    @Input('selectable') public selectable: boolean = false;
    public allSelected = false;
    constructor() { }

    public isAllSelected() {
        return this.model.data.every(data => data.selected);
    }

    protected toogleAll() {
        let selected = !this.isAllSelected();
        this.model.data.forEach(data => data.selected = selected);
        this.updateSelected();
    }

    private updateSelected() {
        this.selected = this.model.data.filter(data => data.selected);
        this.selectionChange.emit({ value: this.selected });
    }

    protected selectionChanged(data) {
        this.updateSelected();
    }
}






// WEBPACK FOOTER //
// ./src/lib/components/data-grid/mdl-data-grid.component.ts